import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preview-canvas-container" }
const _hoisted_2 = { class: "canvas-wrapper" }
const _hoisted_3 = {
  ref: "previewCanvas",
  class: "preview-canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512),
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ]))
}